(function() {
  console.log('Variant preselect script loaded');
  
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  
  console.log('Variant ID from URL:', variantId);
  
  if (!variantId) {
    console.log('No variant parameter found');
    return;
  }
  
  function selectVariant() {
    console.log('Attempting to select variant...');
    
    fetch(window.location.pathname + '.js')
      .then(res => res.json())
      .then(product => {
        console.log('Product data:', product);
        
        const selectedVariant = product.variants.find(v => v.id == variantId);
        console.log('Found variant:', selectedVariant);
        
        if (!selectedVariant) {
          console.log('Variant not found!');
          return;
        }
        
        const variantSelects = document.querySelector('variant-selects') || document.querySelector('variant-radios');
        console.log('Variant selector element:', variantSelects);
        
        if (variantSelects) {
          product.options.forEach((option, index) => {
            const optionValue = selectedVariant.options[index];
            console.log(`Setting option ${option}: ${optionValue}`);
            
            const radios = variantSelects.querySelectorAll(`input[type="radio"]`);
            console.log('Found radios:', radios.length);
            
            radios.forEach(radio => {
              if (radio.value === optionValue) {
                console.log('Checking radio:', radio);
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });
        }
      })
      .catch(err => console.error('Error:', err));
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(selectVariant, 500);
    });
  } else {
    setTimeout(selectVariant, 500);
  }
})();